import { render, staticRenderFns } from "./iocs-manage.vue?vue&type=template&id=55155ced&"
import script from "./iocs-manage.vue?vue&type=script&lang=js&"
export * from "./iocs-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports